export default __webpack_public_path__ + "static/N0127-b72fe7ebaaf03464d8672b88fcf6e7a2.png";